"use client";

import { motion } from "framer-motion";

interface WorkSectionHeadingProps {
  title: string;
  intro: string;
}

export function WorkSectionHeading({ title, intro }: WorkSectionHeadingProps) {
  return (
    <motion.div
      data-cy="work-section-heading"
      className="mb-8"
      initial={{ opacity: 0, y: -10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <h2 className="text-2xl md:text-3xl font-bold mb-3 text-[#ff88ff]">{title}</h2>
      <p className="text-md text-content max-w-3xl">{intro}</p>
    </motion.div>
  );
}
